import { 
    ISO_DASHBOARD_START_LOADING, 
    ISO_DASHBOARD_END_LOADING, 
    SET_ISO_DASHBOARD_FILTER_SEARCH,
    SET_ISO_DASHBOARD_FILTER_MINE_ONLY,
    ISO_DASHBOARD_DRAFT_LOADED, 
    ISO_DASHBOARD_NEW_LOADED,
    ISO_DASHBOARD_SALES_ACTION_LOADED,
    ISO_DASHBOARD_CALCULATE_MAN_DAYS_LOADED,
    ISO_DASHBOARD_SCHEDULING_LOADED,
    ISO_DASHBOARD_AUDIT_IN_PROGRESS_LOADED,
    ISO_DASHBOARD_DOCUMENT_REVIEW_LOADED,
    ISO_DASHBOARD_TECHNICAL_REVIEW_LOADED,
    ISO_DASHBOARD_DECISION_MAKING_LOADED,
    ISO_DASHBOARD_CERTIFICATE_GENERATION_LOADED,
    ISO_DASHBOARD_COMPLETED_LOADED,
    ISO_DASHBOARD_CLOSED_LOADED,
    ISO_DASHBOARD_ABORTED_LOADED,
    ISO_DASHBOARD_CERTIFICATION_ADMIN_USER_LOADED,
    ISO_DASHBOARD_SAC_MDC_ISSUER_USER_LOADED,
    ISO_DASHBOARD_NON_SAC_MDC_ISSUER_USER_LOADED,
    ISO_DASHBOARD_SCHEDULING_RESPONSIBLE_USER_LOADED,
    ISO_DASHBOARD_AUDIT_DOCUMENT_REVIEWER_USER_LOADED,
    ISO_DASHBOARD_TECHNICAL_REVIEWER_USER_LOADED,
    ISO_DASHBOARD_DECISION_MAKER_USER_LOADED,
    ISO_DASHBOARD_USER_SEARCH_LOADED
} from "../constants/IsoDashboardConstants";

const initialState = {
    loading: false,
    search: "",
    mineOnly: true,
    draftList: [],
    newList: [],
    salesActionList: [],
    calculateManDaysList: [],
    schedulingList: [],
    auditInProgressList: [],
    documentReviewList: [],
    technicalReviewList: [],
    decisionMakingList: [],
    certificateGenerationList: [],
    completedList: [],
    closedList: [],
    abortedList: [],
    certificationAdminUserList: [],
    sacMdcIssuerUserList: [],
    nonSacMdcIssuerUserList: [],
    schedulingResponsibleUserList: [],
    auditDocumentReviewerUserList: [],
    technicalReviewerUserList: [],
    decisionMakerUserList: [],
    searchList: []
};

const IsoDashboardReducer = (state = initialState, action) => {
    switch(action.type) {
        case ISO_DASHBOARD_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case ISO_DASHBOARD_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_ISO_DASHBOARD_FILTER_SEARCH:
            return {
                ...state,
                search: action.payload
            };
        case SET_ISO_DASHBOARD_FILTER_MINE_ONLY:
            return {
                ...state,
                mineOnly: action.payload
            };
        case ISO_DASHBOARD_DRAFT_LOADED:
            return {
                ...state,
                draftList: action.payload
            };
        case ISO_DASHBOARD_NEW_LOADED:
            return {
                ...state,
                newList: action.payload
            };
        case ISO_DASHBOARD_SALES_ACTION_LOADED:
            return {
                ...state,
                salesActionList: action.payload
            };
        case ISO_DASHBOARD_CALCULATE_MAN_DAYS_LOADED:
            return {
                ...state,
                calculateManDaysList: action.payload
            };
        case ISO_DASHBOARD_SCHEDULING_LOADED:
            return {
                ...state,
                schedulingList: action.payload
            };
        case ISO_DASHBOARD_AUDIT_IN_PROGRESS_LOADED:
            return {
                ...state,
                auditInProgressList: action.payload
            };
        case ISO_DASHBOARD_DOCUMENT_REVIEW_LOADED:
            return {
                ...state,
                documentReviewList: action.payload
            };
        case ISO_DASHBOARD_TECHNICAL_REVIEW_LOADED:
            return {
                ...state,
                technicalReviewList: action.payload
            };
        case ISO_DASHBOARD_DECISION_MAKING_LOADED:
            return {
                ...state,
                decisionMakingList: action.payload
            };
        case ISO_DASHBOARD_CERTIFICATE_GENERATION_LOADED:
            return {
                ...state,
                certificateGenerationList: action.payload
            };
        case ISO_DASHBOARD_COMPLETED_LOADED:
            return {
                ...state,
                completedList: action.payload
            };
        case ISO_DASHBOARD_CLOSED_LOADED:
            return {
                ...state,
                closedList: action.payload
            };
        case ISO_DASHBOARD_ABORTED_LOADED:
            return {
                ...state,
                abortedList: action.payload
            };
        case ISO_DASHBOARD_CERTIFICATION_ADMIN_USER_LOADED:
            return {
                ...state,
                certificationAdminUserList: action.payload
            };
        case ISO_DASHBOARD_SAC_MDC_ISSUER_USER_LOADED:
            return {
                ...state,
                sacMdcIssuerUserList: action.payload
            };
        case ISO_DASHBOARD_NON_SAC_MDC_ISSUER_USER_LOADED:
            return {
                ...state,
                nonSacMdcIssuerUserList: action.payload
            };
        case ISO_DASHBOARD_SCHEDULING_RESPONSIBLE_USER_LOADED:
            return {
                ...state,
                schedulingResponsibleUserList: action.payload
            };
        case ISO_DASHBOARD_AUDIT_DOCUMENT_REVIEWER_USER_LOADED:
            return {
                ...state,
                auditDocumentReviewerUserList: action.payload
            };
        case ISO_DASHBOARD_TECHNICAL_REVIEWER_USER_LOADED:
            return {
                ...state,
                technicalReviewerUserList: action.payload
            };
        case ISO_DASHBOARD_DECISION_MAKER_USER_LOADED:
            return {
                ...state,
                decisionMakerUserList: action.payload
            };
        case ISO_DASHBOARD_USER_SEARCH_LOADED:
            return {
                ...state,
                searchList: action.payload
            };
        default:
            return state;
    }
}

export default IsoDashboardReducer;